// extracted by mini-css-extract-plugin
export default {"container":"privacy_container__XDMS4","innerCon":"privacy_innerCon__22mNS"};